import React, { useMemo } from 'react';

import type { Paths } from '@zg-rentals/paths-manifest';

import { RMWContext } from '../RMWContext';

type Props = {
  brand: string;
  isInMobileWebView: boolean;
  isLayoutHorizontal?: boolean;
  paths: Paths;
  children: React.ReactNode;
};

const RMWProvider = ({ brand, isInMobileWebView, isLayoutHorizontal = false, paths, children }: Props) => {
  const contextValue = useMemo(
    () => ({ brand, isInMobileWebView, isLayoutHorizontal, paths }),
    [brand, isInMobileWebView, isLayoutHorizontal, paths],
  );

  return <RMWContext.Provider value={contextValue}>{children}</RMWContext.Provider>;
};

export default RMWProvider;
